(function () {
  'use strict';

  angular
      .module('tfc.retailer.Purchase')
      .controller('PurchaseAttributesCtrl', PurchaseAttributesCtrl)
      .constant('ChartType',{
        SalesByAttribute :'salesByAttribute',
        SalesByConsumerAge: 'salesByConsumerAge',
        SalesByConsumerBmi : 'salesByConsumerBmi'
      });

  // @ngInject
  function PurchaseAttributesCtrl($state, userBrands, hierarchyFilter, salesByConsumerAge, salesByConsumerBmi,
                                  salesByAttribute, CookieJar, $stateParams, attributeFilter, attributeValueFilter, translateFilter,
                                  ChartType, PurchaseAttributeReport, GaUtil, filters, aggregationLogDetails,
                                  ChartService) {
    var vm = this;
    vm.brands = userBrands;
    vm.selectedBrand = _.find(vm.brands, {key: $stateParams.brandKey});
    vm.showAllPurchaseByAttributes=false;
    vm.pageType = translateFilter('reports.purchases');
    vm.aggregationDetails = aggregationLogDetails;
    vm.hierarchyFilter = hierarchyFilter;
    vm.attributeFilter = attributeFilter;
    vm.attributeValueFilter = attributeValueFilter;

    vm.activityRegionFilters = filters;

    var selectedTransaction = vm.activityRegionFilters && vm.activityRegionFilters.getSelected();
    var selectedRegion = selectedTransaction && selectedTransaction.getSelectedRegion();

    vm.selectActivityAndReload = function(activity){
      selectedTransaction = activity;
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Activity Filter', activity.label);
      vm.reload(false, false, false);
    };

    vm.selectRegionAndReload = function (region) {
      selectedRegion = region;
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Region Filter', region.labelDescription);
      vm.reload(false, false, false);
    };

    vm.gaUtil = GaUtil;
    vm.charts = {
      salesByAttribute : salesByAttribute,
      salesByConsumerAge : salesByConsumerAge,
      salesByConsumerBmi : salesByConsumerBmi
    };

    vm.dataAvailable = function(source) {
      return vm.charts[source] && vm.charts[source].data ? vm.charts[source].data.length > 0 : vm.charts[source] && vm.charts[source].length > 0;
    };

    vm.reload = function (resetHierarchy, resetAttribute, resetAttributeValue) {
      CookieJar.set({name: 'tfc-insight-selected-brand', value: _.toString(vm.selectedBrand.key)});
      if(resetHierarchy) hierarchyFilter.setSelectedItem(null);
      if(resetAttribute) attributeFilter.setSelectedItem(null);
      if(resetAttributeValue) attributeValueFilter.setSelectedItem(null);

      if (resetHierarchy && resetAttribute && resetAttributeValue) {
        $state.go('.', {brandKey: vm.selectedBrand.key}, {inherit: false});
      } else {
        $state.go('.', {
          brandKey: vm.selectedBrand.key,
          department: hierarchyFilter.getSelectedItemAttribute('department'),
          category: hierarchyFilter.getSelectedItemAttribute('category'),
          attribute: attributeFilter.getSelectedItemAttribute('attribute'),
          attributeValue: attributeValueFilter.getSelectedItemAttribute('attributeValue'),
          transaction: selectedTransaction && selectedTransaction.getLabel(),
          region: selectedRegion && selectedRegion.getLabel()
        });
      }
    };


    vm.reload(false, false, false);

    vm.selectedBrandReload = function (selectedBrand) {
      vm.selectedBrand = selectedBrand;
      vm.reload(true, true, true);
    };

    function setSalesByAttribute(source, dataObject) {
      vm.charts[source] = _.defaultsDeep({data : dataObject}, vm.charts[source], {
        brandKey : vm.selectedBrand.key,
        dontRank : true,
        fn : {
          label : function(d) {
            return d.label;
          },
          value : _.property('percent'),
          color : '#7C0A40',
          valueLabel : function (d) {
            return (d.percent * 100).toFixed(1) + '%';
          },
          highlight : function (d) {
            return d.label === (vm.selectedAttributeValue && vm.selectedAttributeValue.display);
          }
        }
      });
    }

    vm.setAll = function () {
      vm.setSalesAttributeChart(ChartType.SalesByAttribute, vm.charts.salesByAttribute);
      setSalesByAttribute(ChartType.SalesByConsumerAge, vm.charts.salesByConsumerAge);
      setSalesByAttribute(ChartType.SalesByConsumerBmi, vm.charts.salesByConsumerBmi);
    };

    vm.setSalesAttributeChart = function(source, dataObject){
      _.map(dataObject, function(response) {
        var chartData = {chartData: angular.copy(ChartService.getBarChartWithoutLabel([response]))};
        _.assign(response, chartData);
      });
    };

    vm.setAll();

    vm.downloadReport = function(type) {
      PurchaseAttributeReport.downloadReport(type, vm.selectedBrand.key,
          vm.hierarchyFilter.getSelectedItemAttribute('department'),
          vm.hierarchyFilter.getSelectedItemAttribute('category'),
          vm.attributeFilter.getSelectedItemAttribute('attribute'),
          vm.attributeValueFilter.getSelectedItemAttribute('attributeValue'),
          selectedRegion && selectedRegion.getLabel(),
          selectedTransaction && selectedTransaction.getLabel(),
          vm.activityRegionFilters && vm.activityRegionFilters.hasMultipleActivity(),
          selectedTransaction && selectedTransaction.hasMultipleRegion());
    }
  }
})();